import UserDataService from 'src/modules/userData/userDataService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'USERDATA_VIEW';

const userDataViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: userDataViewActions.FIND_STARTED,
      });

      const record = await UserDataService.find(id);

      dispatch({
        type: userDataViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: userDataViewActions.FIND_ERROR,
      });

      getHistory().push('/user-data');
    }
  },
};

export default userDataViewActions;
